module.exports = __webpack_public_path__ + "media/images/icon-right-short-9d881e6e574d951639dd35c7b5b32d66.svg";